<template>
    <el-dialog
        title=""
        width="60%"
        :visible.sync="show"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :show-close="endReached"
        :append-to-body="true"
        @close="onClose"
    >
        <div
            v-if="isLoading"
            v-loading="isLoading"
            class="loading-audit-report"
            :element-loading-text="isDownloadModal ? getText('audit_report_pdf_generation_loading_message') : getText('audit_report_pdf_preparation_loading_message')"
        >

        </div>
        <div v-else-if="!isLoading && endReached && !hasError">
            <el-alert type="success" :title="successMessage" show-icon :closable="false"></el-alert>
            <div
              v-if="result"

            >

              <el-link
                v-if="isDownloadModal"
                :href="result.report"
                target="_blank"
                class="greenButton download-green-button"
                icon="el-icon-download"
                @click="close"
              >
                {{ getText('audit_report_download_button') }}
              </el-link>
            </div>
        </div>
        <div v-else-if="!isLoading && endReached && hasError">
            <el-alert type="error" :title="errorMessage" show-icon :closable="false"></el-alert>
        </div>
        <span slot="footer">
            <el-button :disabled="isLoading" @click="show = false">{{ getText('close_button') }}</el-button>
        </span>
    </el-dialog>
</template>

<script>
import Mixin from 'fundation-app-vuejs/src/components/partials/waitingMixin';
import { mapGetters } from 'vuex';
export default {
    mixins: [Mixin],
    components: {

    },

    props: {
        isDownloadModal: {
            type: Boolean,
            required: true
        }
    },

    data (){
        return {
            show: false,
        };
    },

    computed: {
        ...mapGetters([
            'getText'
        ]),
        successMessage() {
            if (this.isDownloadModal) {
                return this.getText('audit_report_pdf_generation_success_message')
            } else {
                return this.getText('audit_report_pdf_preparation_success_message')
            }
        },
        errorMessage() {
            if (this.result.verbose_status !== '') {
                return this.result.verbose_status
            } else {
                if (this.isDownloadModal) {
                    return this.getText('audit_report_pdf_generation_error_message')
                } else {
                    return this.getText('audit_report_pdf_preparation_error_message')
                }
            }
        }
    },

    mounted (){
    },

    methods: {
        open (url){
            this.show = true;
            this.watchRequestStatus(url);
        },
        close (url){
            this.show = false;
        },
        onClose (){

        }
    },
};
</script>

<style lang="scss">
    .loading-audit-report{
        min-height: 200px;
        .el-loading-text{
            color: #c4d600 !important;
            font-size: 30px;
            margin-top: 30px;
        }
    }
    .download-green-button {
        width: 350px;
        display: block;
        margin: 20px auto 0;
        &:hover {
    background: #c4d600;
            text-decoration: none;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/page/report/waitingModal.vue